var _a;
import { GLOBAL_TINI as BASE_GLOBAL_TINI } from 'tinijs';
export const MODULE_NAME = 'core';
export const MODULE_ID = `tini:${MODULE_NAME}`;
export const GLOBAL_TINI = BASE_GLOBAL_TINI;
export const TINI_APP_CONTEXT = ((_a = GLOBAL_TINI).appContext || (_a.appContext = {}));
export const APP_ROOT = 'app-root';
export const SPLASHSCREEN_ID = 'splashscreen';
export const NO_APP_ERROR = new Error('No TiniJS app available.');
export const NO_REGISTER_ERROR = (id) => new Error(`No register for the dependency "${id}".`);
export var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["App"] = "app";
    ComponentTypes["Layout"] = "layout";
    ComponentTypes["Page"] = "page";
    ComponentTypes["Component"] = "component";
})(ComponentTypes || (ComponentTypes = {}));
export var LifecycleHooks;
(function (LifecycleHooks) {
    LifecycleHooks["OnCreate"] = "onCreate";
    LifecycleHooks["OnDestroy"] = "onDestroy";
    LifecycleHooks["OnInit"] = "onInit";
    LifecycleHooks["OnReady"] = "onReady";
    LifecycleHooks["OnChanges"] = "onChanges";
    LifecycleHooks["OnFirstRender"] = "onFirstRender";
    LifecycleHooks["OnRenders"] = "onRenders";
    LifecycleHooks["OnChildrenRender"] = "onChildrenRender";
    LifecycleHooks["OnChildrenReady"] = "onChildrenReady";
})(LifecycleHooks || (LifecycleHooks = {}));
export var RenderStatuses;
(function (RenderStatuses) {
    RenderStatuses["Loading"] = "loading";
    RenderStatuses["Empty"] = "empty";
    RenderStatuses["Error"] = "error";
    RenderStatuses["Fulfilled"] = "fulfilled";
})(RenderStatuses || (RenderStatuses = {}));
//# sourceMappingURL=consts.js.map